import React from 'react';
import { NavLink } from 'react-router-dom';
import './social-gallery.css';

const sections = [
  ['Settings', '/social-gallery/settings'],
  ['Gallery Leads', '/social-gallery/leads'],
  ['Gallery Performance', '/social-gallery/reports'],
];

export default function GalleryNavigation() {
  return <nav className="sg-section-navigation" aria-label="Social Gallery sections">
    {sections.map(([label, path]) => <NavLink key={path} to={path} activeClassName="is-active">{label}</NavLink>)}
  </nav>;
}
